import ReactDOM from 'react-dom'
import { initializeApp } from 'firebase/app'
import './index.css'
import Login from './login'
import Dashboard from './dashboard'
import AdminPanel from './adminpanel'

import { Outlet, ReactLocation, Router } from 'react-location'

const location = new ReactLocation()

const firebaseConfig = {
  apiKey: 'AIzaSyD0OX3aNvkCTLhW_zfP6JGA9pUkLXWNsL8',
  authDomain: 'sercacadorapp.firebaseapp.com',
  projectId: 'sercacadorapp',
  storageBucket: 'sercacadorapp.appspot.com',
  messagingSenderId: '49786454733',
  appId: '1:49786454733:web:e36b36f6b11848d43e5f84',
}

function Root() {
  const app = initializeApp(firebaseConfig)

  return (
    <Router
      location={location}
      routes={[
        { path: '/', element: <Login /> },
        {
          path: '/dashboard',
          element: <Dashboard firebaseApp={app} />,
        },
        { path: '/admin', element: <AdminPanel firebaseApp={app} /> },
      ]}
    >
      <Outlet /> {/* Start rendering router matches */}
    </Router>
  )
}

const rootElement = document.getElementById('root')
ReactDOM.render(<Root />, rootElement)
